import React from 'react';
import { JoraEmployerHelmet } from '@common/components/Helmet';
import { useRedirectUnauthenticatedUser } from '@common/hooks/useRedirectUnauthenticatedUser';
import { useTranslation } from '@common/hooks/useTranslation';
import { useCurrentUser } from '@common/hooks/user';
import { BackToJobsLink, WhatHappensNextInfo } from '../../components';
import { HeaderInfo } from './HeaderInfo';

export const PaymentSuccess = () => {
  useRedirectUnauthenticatedUser();

  const { t } = useTranslation();
  const { email } = useCurrentUser();

  return (
    <div className="flex flex-col gap-md mb-md">
      <JoraEmployerHelmet title={t('paymentSuccessPage.title')} />
      <HeaderInfo />
      <WhatHappensNextInfo emailAddress={email!} />
      <BackToJobsLink />
    </div>
  );
};
